import React from 'react';
import { connect } from 'react-redux';
import '@/assets/styles/pages/trading-page.scss';
import TabHeader from '@/components/TabHeader/TabHeader';
import OrderBookMobile from '@/components/OrderTable/OrderBook.mobile';
import OrderHistoryMobile from '@/components/OrderTable/OrderHistory.mobile';

const ORDER_BOOK_TABLE = 3;
const ORDER_HISTORY_TABLE = 4;

class TradeMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tradeTabs:[
        {id:1,title:'order_book_title'},
        {id:2,title:'order_history_title'}
      ],
      orderTableTab: ORDER_BOOK_TABLE,
    }
  }

  render() {
    const { language, currentTradingAccount } = this.props;
    const { tradeTabs , orderTableTab} = this.state;
    return (
      <React.Fragment>
        <div className='trading-mobile-container'>
                <TabHeader
                  TabHeader tabs={tradeTabs}
                  onChange={this.handleChangeOrderTableTab}
                  // maximumDate={maximumDate}
                  // onChangeDatePicker={this.handleChangeDatePicker}
                  // onChangeMarket={this.handleChangeMarket}
                />
                {orderTableTab === ORDER_BOOK_TABLE && <OrderBookMobile innerRef={e => this.orderBookRef = e} />}
                {orderTableTab === ORDER_HISTORY_TABLE && <OrderHistoryMobile innerRef={e => this.orderHistoryRef = e} />}
        </div>
      </React.Fragment>
    )
  }

  handleChangeOrderTableTab = (tab) => {
    switch (tab.main.title) {
      case 'order_book_title': {
        this.setState({
          orderTableTab: ORDER_BOOK_TABLE,
          searchParams: {
            status: '',
            startDate: '',
            endDate: ''
          }
        })
        break;
      }
      case 'order_history_title': {
        // const maximumDate = this.getMaximumDate();
        this.setState({
          orderTableTab: ORDER_HISTORY_TABLE,
          // searchParams: {
          //   status: '',
          //   startDate: this.convertDateObjectToString(maximumDate),
          //   endDate: this.convertDateObjectToString(maximumDate)
          // }
        }, () => {
          // this.tabHeaderOrderRef.setDatePickerValue(maximumDate);
        })
        break;
      }
      default: break;
    }
  }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
  })
)(TradeMobile)
